import { Component, Vue } from 'vue-property-decorator'

@Component({
})
export default class CategoryBase extends Vue {
	get categories() {
		return this.$store.getters.categories
	}

	get categoriesLoading() {
		return this.categories.loading
	}

	get categoriesParentValues() {
		const values = this.categories.models.map((category) => ({ key: category.id, value: category.name }))
		values.unshift({ key: 0, value: '(Top)' })
		return values
	}

	protected pageParentStringValue(id: number) {
		const selected = this.categoriesParentValues.find((el: any) => el.key === id)
		if (selected) {
			return selected.value
		}
		return ''
	}
}
